import {
  AddSiteRequest,
  AddSiteResponse,
  PlanResponse,
  UpdateGlobalSettingsParams,
  UpdateUserNameParams,
  UserGlobalSettingsParams,
  UserGlobalSettingsResponse,
  UserParams,
  UserProfileParams,
  UserResponse,
} from 'types/api/user';
import { baseApi } from './baseApi';

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<UserResponse, UserParams>({
      query: (params) => ({
        url: `/user${params?.workspace_id ? `?workspace_id=${params.workspace_id}` : ''}`,
        method: 'GET',
      }),
      providesTags: (_, error, params) => {
        if (error) return [];
        return [{ type: 'User', id: params?.workspace_id || 0 }];
      },
    }),
    getUserGlobalSettings: builder.query<
      UserGlobalSettingsResponse,
      UserGlobalSettingsParams
    >({
      query: ({ setting, workspace_id }) =>
        `/user/global-settings?setting=${setting}&workspace_id=${workspace_id}`,
      providesTags: (_, error, { workspace_id }) => {
        if (error) return [];
        return [{ type: 'Setting', id: workspace_id }];
      },
    }),
    fetchUpgradePlans: builder.query<PlanResponse, void>({
      query: () => `/plans/upgrade-plans`,
      // transformResponse: (response: PlanResponse) => response.result as Plan[],
      providesTags: (_, error) => {
        if (error) return [];
        return [{ type: 'UpgradePlans', id: 'LIST' }];
      },
    }),
    removeCollaborator: builder.mutation<AddSiteResponse, AddSiteRequest>({
      query: (body) => ({
        url: '/user/add-site',
        method: 'POST',
        body,
      }),
      // Invalidate the Project list cache when a new site is added
      invalidatesTags: [
        { type: 'Project', id: 'LIST' },
        { type: 'Site', id: 'LIST' },
      ],
    }),
    updateGlobalSettings: builder.mutation<unknown, UpdateGlobalSettingsParams>(
      {
        query: (body) => ({
          url: '/user/update-global-settings',
          method: 'POST',
          body,
        }),
        invalidatesTags: (_, error, { workspace_id }) => {
          if (error) return [];
          return [{ type: 'Setting', id: workspace_id }];
        },
      }
    ),
    updateUserDetail: builder.mutation<unknown, UpdateUserNameParams>({
      query: (body) => ({
        url: `/api-change-password`,
        method: 'POST',
        body: {
          name: body.name,
          new_password: body.new_password,
          new_password_confirmation: body.new_password_confirmation,
        },
      }),
      invalidatesTags: (_, error, { workspace_id }) => {
        if (error) return [];
        return [{ type: 'User', id: workspace_id }];
      },
    }),
    updateUserProfile: builder.mutation<unknown, UserProfileParams>({
      query: (body) => ({
        url: `/user/update-profile/${body.userId}?workspace_id=${body.workspace_id}`,
        method: 'POST',
        body: body.data,
      }),
      invalidatesTags: (_, error, { workspace_id }) => {
        if (error) return [];
        return [{ type: 'User', id: workspace_id }];
      },
    }),
  }),
});

export const {
  useLazyGetUserGlobalSettingsQuery,
  useLazyGetUserQuery,
  useGetUserGlobalSettingsQuery,
  useGetUserQuery,
  useFetchUpgradePlansQuery,
  useRemoveCollaboratorMutation,
  useUpdateGlobalSettingsMutation,
  useUpdateUserDetailMutation,
  useUpdateUserProfileMutation,
} = userApi;
